import { Component, Input } from '@angular/core';

import { CardComponent } from '../card/card.component';

/**
 * DashboardWrapperComponent
 *
 * A reusable wrapper component for dashboard layouts with filter and table sections.
 * Provides consistent structure and styling for both supplier/carrier and engineering dashboards.
 *
 * Usage:
 * <app-dashboard-wrapper [title]="'Route Signoffs'" [hasData]="rows.length > 0">
 *   <app-filters-component
 *     appDashboardFilter
 *     (applyFilters)="onFiltersApplied($event)">
 *   </app-filters-component>
 *
 *   <app-table-component
 *     appDashboardTable
 *     [rows]="rows">
 *   </app-table-component>
 *
 *   <ryui-pagination
 *     appDashboardPagination
 *     [pages]="totalPages"
 *     [currentPage]="page"
 *     (pageChange)="pageChange($event)">
 *   </ryui-pagination>
 * </app-dashboard-wrapper>
 */
@Component({
    selector: 'app-dashboard-wrapper',
    imports: [CardComponent],
    templateUrl: './dashboard-wrapper.component.html',
    styleUrls: ['./dashboard-wrapper.component.scss']
})
export class DashboardWrapperComponent {
    /**
     * Title to display at the top of the dashboard
     */
    @Input() title: string = '';

    /**
     * Flag indicating whether data is available to display
     * When false, "No Data" message will be shown
     */
    @Input() hasData: boolean = false;

    /**
     * Optional custom no-data message text
     * Default is 'No Data'
     */
    @Input() noDataMessage: string = 'No Data';
}
